

const four = [[4,4]];

const five = new Array(3).fill(0).map((val, ind) => {
    return [5, ind + 3]
})

const six = new Array(5).fill(0).map((val, ind) => {
    return [6, ind + 2]
})

const seven = new Array(7).fill(0).map((val, ind) => {
    return [7, ind + 1]
})

const eight = new Array(8).fill(0).map((val, ind) => {
    return [8, ind + 1]
})

const nine = new Array(9).fill(0).map((val, ind) => {
    return [9, ind + 1]
})

const ten = new Array(10).fill(0).map((val, ind) => {
    return [10, ind + 1]
})


const tests = four.concat(five).concat(six).concat(seven).concat(eight).concat(nine).concat(ten) 

export default tests;